import { APICore } from "./apiCore";

const api = new APICore();

function getComplaints(issueType?: string, status?: string, page?: number, limit?: number) {
  const baseUrl = `/web/complaints`;
  const params: any = {};
  if (issueType) params.issueType = issueType;
  if (status) params.status = status;
  if (page) params.page = page;
  if (limit) params.limit = limit;
  return api.get(`${baseUrl}`, params);
}

function changeComplaintStatusApi(params: { complaintId: string; status: string }) {
  const baseUrl = "/web/complaints-status";
  return api.updatePatch(`${baseUrl}/${params.complaintId}`, { status: params.status });
}

export { getComplaints, changeComplaintStatusApi };
